import { ZIP_CODE_STATUS } from './constants';

interface UseStatusProps {
  zipCode: string;
  zipCodeIsValid: boolean;
  isFetching: boolean;
  isError: boolean;
}

export default function useStatus(props: UseStatusProps): {
  state: 'valid' | 'invalid' | 'loading' | 'idle';
  hint: string;
} {
  const { zipCode, isError, isFetching, zipCodeIsValid } = props;

  if (zipCode.length === 0) {
    return ZIP_CODE_STATUS.idle;
  }

  if (!zipCodeIsValid) {
    return ZIP_CODE_STATUS.invalid;
  }

  if (isFetching) {
    return ZIP_CODE_STATUS.fetching;
  }

  if (isError) {
    return ZIP_CODE_STATUS.error;
  }

  return ZIP_CODE_STATUS.valid;
}
